import React from 'react';

export default function ForecastControl({ forecastDays, scheduleEnabled, onChange }) {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold mb-4">Forecast & Control</h3>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Forecast Horizon: {forecastDays} days
          </label>
          <input
            type="range"
            min="1"
            max="60"
            value={forecastDays}
            onChange={(e) => onChange({ forecast_days: parseInt(e.target.value) })}
            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
          />
          <div className="flex justify-between text-xs text-gray-500 mt-1">
            <span>1 day</span>
            <span>60 days</span>
          </div>
        </div>

        <div className="flex items-center">
          <input
            type="checkbox"
            id="scheduleEnabled"
            checked={scheduleEnabled}
            onChange={(e) => onChange({ schedule_enabled: e.target.checked })}
            className="h-4 w-4 text-blue-600 rounded border-gray-300"
          />
          <label htmlFor="scheduleEnabled" className="ml-2 text-sm text-gray-700">
            Enable Scheduled Repricing
          </label>
        </div>
      </div>
    </div>
  );
}
